
const dialog = require('../../../../../components/dialog/dialog')

function getItemDtCell(dbid) {
	const row = document.getElementById(`item-tableRow-${dbid}`)
	const sourceCell = row?.querySelector('.tdWithAvatar')

	if (!sourceCell) {
		return ''
	}

	const cell = sourceCell.cloneNode(true)
	cell.removeAttribute('data-detail')
	cell.style.width = '100%'

	return `
		<div class="dt" style="padding: 0; margin-top: 12px; margin-bottom: 16px; pointer-events: none;">
			<table style="width: 100%;">
				<tbody>
					<tr style="height: 36px;">${cell.outerHTML}</tr>
				</tbody>
			</table>
		</div>
	`
}

export function start(detail) {

	dialogBody[detail.id].start(detail)

	detail.html = dialogBody[detail.id]
	dialog.start(detail)
}

const dialogBody = {

	dialogUpdateSellingPrice: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Update',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: 'Cancel',
			class: 'button secondary  button-plain',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: 'button secondary  button-plain',
			dataDetail: '',
		},

		start: function (detail) {

			this.title = 'Update Selling Price'
			this.des = ''
			const itemDtCell = getItemDtCell(detail.dbid)
			this.primary.dataDetail = `data-detail='{
	                       				  "click": [ {"dest":"ripple" }, 
	                                      {"dest":"item", "elem":"dt",  "id":"item-dt", "act":"confirmUpdateSellingPrice", "entity":"item", "dbid":"${detail.dbid}",
										  "item_unit_id":"${detail.item_unit_id}"} ]}'`
			this.secondary.dataDetail = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
			this.bodyHtml = `
				<div class="row" style='min-width: 400px;'>
					<label class="font-des-red" style="margin-top: 8px;">
						Only selling prices for items with available inventory will be updated.
					</label>

					${itemDtCell}
		
					<div class="c100 mt-8">
						<div class="textfield textfield-cash  textfield-desk" >
							<input autocomplete="off"  class= 'elem' type="number" min="1" max="10" step="1" id="inputUpdateSellingPrice"
								data-detail='{ "key":   [ {"dest":"textfield", "act":"typing"  }]  }' value="" >
							<div class="label">Selling Price</div> 
						</div><!-- textfield -->
					</div>
		
				</div>	
			`
		}
	},

	confirmUpdateSellingPrice: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Accept',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: 'Cancel',
			class: 'button secondary  button-plain',
			dataDetail: '',
		},
		tertiary: {
			text: '',
			class: 'button secondary  button-plain',
			dataDetail: '',
		},


		start: function (detail) {
			this.title = 'WARNING'
			//this.des       = 'You want to save the data knowing that one of the selling prices of your item is less than the unit price'
			this.des = `Are you sure? The selling price will be updated in all purchases where this item still has available inventory
							    , based on the value you just entered.`
			this.primary.dataDetail = `data-detail='{
										"click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
									{"dest":"item", "elem":"dt",  "id":"item-dt", "act":"updateSellingPrice", "entity":"item", "dbid":"${detail.dbid}",
									   "item_unit_id":"${detail.item_unit_id}", "newSellingPrice":"${detail.newSellingPrice}"} ]}'`
			this.secondary.dataDetail = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
		}

	},

}